import React, { useContext, useEffect } from 'react'
import { Box, Text } from '@chakra-ui/react'
import { Messages } from '@probe/shared'
import { Communicator } from '../../communication/communicator'
import { CommunicatorContext } from '../../communication/communicator-context'

type Props = {}

export const ProbeVersions = ({}: Props) => {
    const communicator = useContext(CommunicatorContext)

    useEffect(() => {
        const handler: Communicator.NotificationHandler = {
            handle: (notification: Messages.Notification): boolean => {
                console.log('GOT NOTIFICATION', notification)
                return false
            }
        }

        communicator.addHandler(handler)
        return () => communicator.removeHandler(handler)
    }, [communicator])

    return (
        <Box px={4} py={2}>
            <Text>Hello2</Text>
        </Box>
    )
}
